import { ArrowUpRight } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { photo, useLanguage } from '../lib/site';
import { Reveal } from './Shared';
import './MenuPhotos.css';

const highlights = [
  {
    image: 'menu-desserts', category: 'sweets',
    title: ['O pauză dulce.', 'A sweet little break.'],
    detail: ['Clătite, waffles & langoși cu ciocolată', 'Crêpes, waffles & chocolate lángos'],
    alt: ['Langoș cu ciocolată, clătite și waffle pe o masă cu fundal inspirat de terasa OranjinaBiscotina', 'Chocolate lángos, crêpes and a waffle on a table with an OranjinaBiscotina terrace-inspired backdrop'],
  },
  {
    image: 'menu-drinks', category: 'drinks',
    title: ['Un strop de bine.', 'A sip of happiness.'],
    detail: ['Fresh-uri (mic sau mare), frappé, cafea & ciocolată caldă', 'Fresh juices (small or large), frappé, coffee & hot chocolate'],
    alt: ['Fresh de portocale, suc de fructe, frappé, ice latte și espresso într-un decor cald de terasă', 'Orange juice, fruit juice, frappé, iced latte and espresso in a warm terrace setting'],
  },
  {
    image: 'menu-icecream', category: 'sweets',
    title: ['Gust de vară.', 'A taste of summer.'],
    detail: ['Înghețată · disponibilă în sezonul cald', 'Ice cream · available in the warmer months'],
    alt: ['Înghețată de vanilie și ciocolată la cornet, cu un șervet portocaliu și fundal de terasă', 'Vanilla and chocolate soft serve in a waffle cone, with an orange napkin and terrace backdrop'],
  },
  {
    image: 'menu-hot-chocolate', category: 'drinks', width: 678, height: 452,
    title: ['Ciocolată caldă', 'Hot chocolate'],
    detail: ['O pauză caldă, cu gust de ciocolată', 'A cosy little chocolate moment'],
    alt: ['Ciocolată caldă într-o cană de sticlă, cu frișcă și fulgi de ciocolată', 'Hot chocolate in a glass mug, topped with whipped cream and chocolate flakes'],
  },
];

export const MenuPhotos = ({ onSelectCategory }) => {
  const { t } = useLanguage();
  const reduced = useReducedMotion();
  const selectCategory = category => {
    onSelectCategory(category);
    const tab = document.getElementById(`menu-tab-${category}`);
    tab?.focus({ preventScroll: true });
    tab?.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
  };
  return <div className="menu-photography" data-testid="menu-photography">
    <div className="menu-photo-grid">
      {highlights.map((item, index) => <Reveal key={item.image} delay={index * .08}>
        <motion.button type="button" className="menu-photo-card" data-testid={`menu-photo-${item.image}`} onClick={() => selectCategory(item.category)} whileHover={reduced ? {} : { y: -4 }} whileTap={reduced ? {} : { scale: .99 }} aria-label={t(`Vezi meniul: ${item.detail[0]}`, `Explore the menu: ${item.detail[1]}`)}>
          <div className="menu-photo-frame">
            <img data-testid={`menu-image-${item.image}`} src={photo(item.image)} srcSet={`${photo(item.image + '-small')} ${Math.floor((item.width || 1264) / 2)}w, ${photo(item.image)} ${item.width || 1264}w`} sizes="(max-width: 699px) calc(100vw - 40px), (max-width: 959px) 44vw, 24vw" alt={t(...item.alt)} loading="lazy" width={item.width || 1264} height={item.height || 848}/>
            <span className="menu-photo-index" aria-hidden="true">0{index + 1}</span>
          </div>
          <div className="menu-photo-caption"><div><h3 data-testid={`menu-photo-title-${item.image}`}>{t(...item.title)}</h3><p data-testid={`menu-photo-detail-${item.image}`}>{t(...item.detail)}</p></div><ArrowUpRight size={19}/></div>
        </motion.button>
      </Reveal>)}
    </div>
    <p className="menu-photo-note" data-testid="menu-photo-edit-note">{t('Primele trei imagini au fundaluri adaptate cu AI atmosferei OranjinaBiscotina. Fotografia ciocolatei calde este cea furnizată de noi.', 'The first three images have AI-edited backgrounds inspired by OranjinaBiscotina. The hot chocolate photograph is our supplied image.')}</p>
  </div>;
};